:host {
  --toast-max-width: 600px;
  --toast-min-height: 48px;
}

.toast-notification {
  max-width: var(--toast-max-width);
  min-height: var(--toast-min-height);
  height: auto;
  border-radius: var(--input-border-radius);

  display: flex;
  flex-direction: row;

  margin: calc(var(--spacer) + 2px) 0;

  .message {
    min-height: var(--toast-min-height);
    align-items: center;
    font-weight: 500;
    flex-grow: 1;
    padding: calc(2 * var(--spacer)) calc(var(--spacer) + 2px) calc(2 * var(--spacer)) calc(2 * var(--spacer));
    display: flex;

    span {
      font-family: var(--font-family-secondary);
      font-size: var(--body-size-large);

      &::first-line {
        line-height: 1em;
      }
    }
  }

  .message-container {
    flex: 1;
  }

  .close-button {
    margin: calc(var(--spacer) * 1.5) 10px 0 var(--spacer);
  }

  .separator {
    display: flex;
    flex-direction: column;
    justify-content: center;

    &:after {
      content: '';
      width: 1px;
      height: 75%;
      background-color: var(--white-layout-300-primary);
    }
  }
  .icon {
    padding: calc(2 * var(--spacer) - 4px) 0 calc(2 * var(--spacer) - 4px) calc(2 * var(--spacer));
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  &.neutral {
    background-color: var(--body-text-arrows-400);

    .message,
    .action-button {
      color: var(--white-layout-300-primary);
    }
    .icon {
      display: none;
    }
    .separator {
      &:after {
        background-color: var(--white-layout-101-outline-on-dark-background);
      }
    }
  }

  &.informative {
    background-color: var(--blue-layout-402-primary-background);

    .icon::part(svgIcon) {
      fill: var(--white-layout-300-primary);
    }
    .message,
    .action-button {
      color: var(--white-layout-300-primary);
    }
    .separator {
      &:after {
        background-color: var(--white-layout-101-outline-on-dark-background);
      }
    }
  }

  &.success {
    background-color: var(--green-layout-102-primary-green-hc);

    .icon::part(svgIcon) {
      fill: var(--white-layout-300-primary);
    }
    .message,
    .action-button {
      color: var(--white-layout-300-primary);
    }
    .separator {
      &:after {
        background-color: var(--white-layout-101-outline-on-dark-background);
      }
    }
  }

  &.warning {
    background-color: var(--orange-layout-050-warning);

    .icon::part(svgIcon) {
      fill: var(--main-titles-inputs-603);
    }
    .message,
    .action-button {
      color: var(--main-titles-inputs-603);
    }
    gz-button::part(button) {
      border-color: var(--main-titles-inputs-603);
      color: var(--main-titles-inputs-603);
    }
    .separator {
      &:after {
        background-color: var(--grey-layout-201-disabled-text);
      }
    }
  }

  &.error {
    background-color: var(--red-layout-302-primary);

    .icon::part(svgIcon) {
      fill: var(--white-layout-300-primary);
    }
    .message,
    .action-button {
      color: var(--white-layout-300-primary);
    }
    .separator {
      &:after {
        background-color: var(--white-layout-101-outline-on-dark-background);
      }
    }
  }
}

:host([hasaction]) {
  .toast-notification {
    .message-container {
      display: flex;
      flex-direction: column;

      .action-button {
        align-self: flex-end;
        margin: 0 calc(2 * var(--spacer)) calc(var(--spacer) - 1px) 0;
      }
    }
  }
}

:host([showinlinebutton]) {
  .toast-notification {
    .message-container {
      flex-direction: row;

      .action-button {
        align-self: center;
        margin: 0 calc(var(--spacer) + 2px) 0 0;
      }
    }
  }
}
